import React from 'react';
import { css } from '@emotion/react';
import { color } from '@uniquegood/realworld-studio-design';

interface ProgressBarProps {
  /** 진행도를 나타내는 백분율 (0-100) */
  progress: number;
  /** 추가적인 CSS 클래스명 */
  className?: string;
}

const progressBarContainerStyle = css`
  width: 100%;
  height: 4px;
  background-color: #e9ebf1;
  border-radius: 2px;
  overflow: hidden;
`;

const progressBarFillStyle = (progress: number) => css`
  height: 100%;
  background-color: #7800ff;
  border-radius: 2px;
  width: ${Math.min(Math.max(progress, 0), 100)}%;
  transition: width 0.3s ease-in-out;
`;

function ProgressBar({ progress, className }: ProgressBarProps) {
  return (
    <div css={progressBarContainerStyle} className={className}>
      <div css={progressBarFillStyle(progress)} />
    </div>
  );
}

export default ProgressBar;

// 사용 예시:
// <ProgressBar progress={75} /> - 75% 진행
// <ProgressBar progress={0} /> - 0% 진행 (빈 상태)
// <ProgressBar progress={100} /> - 100% 진행 (완료 상태)
// <ProgressBar progress={150} /> - 100% 진행 (150%는 100%로 제한됨)